import Ajax from "Utils/ajax";
export const getDocumentClass = (data) => Ajax.post('setting/getDocumentClass',data);
export const documentCategory = (data) => Ajax.post('hr/documentCategory',data);
export const getDocumentTypeList = (data) => Ajax.post('setting/getDocumentTypeList',data);
export const deleteDocumentType = (data) => Ajax.post('setting/deleteDocumentType',data);
export const addUpdateDocumentType = (data) => Ajax.post('setting/addUpdateDocumentType',data);